import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";
import { initialContactState } from "../../models/ContactModel";

export const fetchContact = createAsyncThunk(
  "contact/fetchContact",
  async (_, thunkAPI) => {
    try {
      const response = await apiService("/Contact/Get");
      if (response.isSuccess) {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response.message || "Hata oluştu");
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const contactSlice = createSlice({
  name: "contact",
  initialState: initialContactState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchContact.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchContact.fulfilled, (state, action) => {
        state.loading = false;
        state.dataContact = action.payload;
      })
      .addCase(fetchContact.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default contactSlice.reducer;
